// ContactPopup.tsx
import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Box,
} from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

export function ContactPopup(): JSX.Element {
  const [open, setOpen] = useState(false);
  const [hasOpened, setHasOpened] = useState(false);
  const [form, setForm] = useState({
    name: "",
    goal: "",
    time: "",
    message: "",
  });

  useEffect(() => {
    const openPopup = () => {
      if (!hasOpened) {
        setOpen(true);
        setHasOpened(true);
      }
    };

    const onScroll = () => {
      const scrolled = window.scrollY + window.innerHeight;
      const halfPage = document.body.scrollHeight / 2;
      if (scrolled >= halfPage) openPopup();
    };

    const timer = setTimeout(openPopup, 15000);
    window.addEventListener("scroll", onScroll);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", onScroll);
    };
  }, [hasOpened]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSend = () => {
    const { name, goal, time, message } = form;
    const whatsappNumber = "972506660706"; // מספר וואטסאפ של גלית
    const text = `היי גלית 
שמי ${name}.
הייתי רוצה לתרגל יוגה כדי ${goal}.
יהיה לי מתאים לתרגל ${time}.
${message ? message + ". " : ""}אשמח לשמוע ממך `;

    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
      text
    )}`;
    window.open(url, "_blank");
    setOpen(false);
  };

  return (
    <>
      <Button
        variant="contained"
        color="success"
        startIcon={<WhatsAppIcon sx={{ mr: 1.5 }} />}
        onClick={() => setOpen(true)}
        sx={{ borderRadius: "20px", px: 3, py: 1 }}
      >
        שלחו הודעה לגלית
      </Button>

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth dir="rtl">
        <DialogTitle textAlign="center" fontWeight={600}>
          דברו עם גלית בוואטסאפ 💬
        </DialogTitle>

        <DialogContent>
          <Box display="flex" flexDirection="column" gap={2} mt={1} sx={{ textAlign: "right" }}>
            <TextField
              label="שם מלא"
              name="name"
              value={form.name}
              onChange={handleChange}
              fullWidth
              required
              variant="outlined"
            />

            <TextField
              select
              label="מטרה"
              name="goal"
              value={form.goal}
              onChange={handleChange}
              fullWidth
              required
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  disablePortal: true,
                  anchorOrigin: { vertical: "bottom", horizontal: "right" },
                  transformOrigin: { vertical: "top", horizontal: "right" },
                },
              }}
            >
              <MenuItem value="להפחית מתחים">להפחית מתחים</MenuItem>
              <MenuItem value="להקל על כאבים">להקל על כאבים</MenuItem>
              <MenuItem value="להתחזק פיזית">להתחזק פיזית</MenuItem>
              <MenuItem value="להיות רגוע/ה יותר">להיות רגוע/ה יותר</MenuItem>
              <MenuItem value="לשפר גמישות">לשפר גמישות</MenuItem>
              <MenuItem value="סיבה אחרת">סיבה אחרת</MenuItem>
            </TextField>

            <TextField
              select
              label="מתי נוח לך לתרגל?"
              name="time"
              value={form.time}
              onChange={handleChange}
              fullWidth
              required
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  disablePortal: true,
                  anchorOrigin: { vertical: "bottom", horizontal: "right" },
                  transformOrigin: { vertical: "top", horizontal: "right" },
                },
              }}
            >
              <MenuItem value="בשעות הבוקר">בשעות הבוקר</MenuItem>
              <MenuItem value="בשעות הערב">בשעות הערב</MenuItem>
            </TextField>

            <TextField
              label="הודעה נוספת (לא חובה)"
              name="message"
              value={form.message}
              onChange={handleChange}
              fullWidth
              multiline
              rows={3}
              variant="outlined"
            />
          </Box>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "space-between", px: 3, pb: 2 }}>
          <Button onClick={() => setOpen(false)}>ביטול</Button>
          <Button
            onClick={handleSend}
            variant="contained"
            color="success"
            startIcon={<WhatsAppIcon sx={{ ml: 1.5 }} />}
            disabled={!form.name || !form.goal || !form.time}
          >
            שלחו הודעה
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
